import {Switch} from 'antd';
import {PropsWithChildren} from 'react';

import {LangKeyType} from '../../../../../../provider/locale/translation/type';
import {Text} from '../../../../../text/text';

import * as styles from './yandex-story-toggle-card.scss';

type PropsType = PropsWithChildren<{
    labelLangKey: LangKeyType;
    isEnabled: boolean;
    onToggle: (isEnabled: boolean) => void;
    disabled?: boolean;
}>;

// Bordered block with a switch in its header, revealing its fields once the switch is on.
export function YandexStoryToggleCard(props: PropsType): JSX.Element {
    const {labelLangKey, isEnabled, onToggle, disabled, children} = props;

    return (
        <div className={styles.YandexStoryToggleCard}>
            <div className={styles.YandexStoryToggleCard_header}>
                <Text stringKey={labelLangKey} />
                <Switch checked={isEnabled} disabled={disabled} onChange={onToggle} />
            </div>

            {isEnabled && <div className={styles.YandexStoryToggleCard_content}>{children}</div>}
        </div>
    );
}
